import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'md' },
  }, overrideReadOnly)
  .nameOverride(['disclaimerText'], {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
      align: 'center',
      color: 'textDisabled',
    },
  }, overrideReadOnly);
